import React from 'react';
import SocialAppFooter from '../../components/Grid/SocialSection/SocialSection';
import ServiceFooter from '../../components/Grid/ServiceSection/ServiceSection';
import ReturnsFooter from '../../components/Grid/ReturnSection/ReturnSection';
import AppFooter from '../../components/Grid/AppSection/AppSection';
import { getSocialMediaAccounts } from '../../utils/socialAccounts';
var socials = getSocialMediaAccounts('argos');

var grid = function grid(nativeLazy) {
  return [{
    title: 'Returning an item',
    component: /*#__PURE__*/React.createElement(ReturnsFooter, null)
  }, {
    title: 'Payment methods',
    component: /*#__PURE__*/React.createElement(ServiceFooter, {
      nativeLazy: nativeLazy
    })
  }, {
    title: 'Follow us',
    component: /*#__PURE__*/React.createElement(SocialAppFooter, {
      nativeLazy: nativeLazy,
      socials: socials
    })
  }, {
    title: 'Download our app',
    component: /*#__PURE__*/React.createElement(AppFooter, {
      nativeLazy: nativeLazy
    })
  }];
};

export default grid;